import { render, staticRenderFns } from "./GoForward.vue?vue&type=template&id=ec04e77e&functional=true&"
import script from "./GoForward.vue?vue&type=script&lang=ts&"
export * from "./GoForward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports